module.exports = Promise.all([__parcel__import__("gkbey"), __parcel__import__("3DhF3")]).then(() => parcelRequire('g36Vt'));